<nav class="navbar" *ngIf="isLandscape" [ngClass]="{'scrolling': scrolled}">
  <img class="logo" src="/assets/images/common/logo.svg" alt="eyesNroad Logo" [routerLink]="getRouterLink('Home')">
  <div class="nav-option platform" [innerHTML]="'header_Data1' |i18n" [routerLink]="getRouterLink('Platform')"></div>
  <div class="nav-option contact" [innerHTML]="'header_Data2' |i18n" [routerLink]="getRouterLink('Contact')"></div>
  <!-- <div class="language-selector">
    <mat-select #languageSelector placeholder="{{ getSelectedLanguageLabel() | i18n: translationModes.PLACEHOLDER }}"
    [(ngModel)]="selectedLanguage" (ngModelChange)="setCurrentLanguage($event)" panelClass="language-selector-panel"
    disableOptionCentering [ngClass]="{'select-open': languageIsOpen}" (openedChange)="handleLanguageSelector()">
      <mat-option *ngIf="selectedLanguage !== 'es'" value="es" [innerHTML]="'header_Data5' |i18n: translationModes.PLACEHOLDER"></mat-option>
      <mat-option *ngIf="selectedLanguage !== 'en'" value="en" [innerHTML]="'header_Data6' |i18n: translationModes.PLACEHOLDER"></mat-option>
      <mat-option *ngIf="selectedLanguage !== 'pt'" value="pt" [innerHTML]="'header_Data7' |i18n: translationModes.PLACEHOLDER"></mat-option>
      <mat-option *ngIf="selectedLanguage !== 'fr'" value="fr" [innerHTML]="'header_Data8' |i18n: translationModes.PLACEHOLDER"></mat-option> -->
      <!-- <mat-option value="eus" [innerHTML]="'header_Data9' |i18n: translationModes.PLACEHOLDER"></mat-option>
      <mat-option value="cat" [innerHTML]="'header_Data10' |i18n: translationModes.PLACEHOLDER"></mat-option>
    </mat-select>
  </div> -->
  <div class="btn register" [innerHTML]="'header_Data3' |i18n" [routerLink]="getRouterLink('Register')"></div>
  <div class="btn login" [innerHTML]="'header_Data4' |i18n" [routerLink]="getRouterLink('Login')"></div>
</nav>

<nav class="navbar" *ngIf="!isLandscape" [ngClass]="{'open': panelIsOpen}">
  <img class="logo" src="/assets/images/common/logo.svg" alt="eyesNroad Logo" [routerLink]="getRouterLink('Home')">
  <div class="menu-icon" (click)="handleOpenChange()">
    <span [ngClass]="{'first-bar': panelIsOpen}"></span>
    <span [ngClass]="{'second-bar': panelIsOpen}"></span>
    <span [ngClass]="{'third-bar': panelIsOpen}"></span>
  </div>
  <div class="header" *ngIf="panelIsOpen">
    <div class="nav-option platform" [innerHTML]="'header_Data1' |i18n" [routerLink]="getRouterLink('Platform')"></div>
    <div class="nav-option contact" [innerHTML]="'header_Data2' |i18n" [routerLink]="getRouterLink('Contact')"></div>
    <!-- <div class="language-selector">
      <mat-select placeholder="{{ getSelectedLanguageLabel() | i18n: translationModes.PLACEHOLDER }}"
        [(ngModel)]="selectedLanguage" (ngModelChange)="setCurrentLanguage($event)" panelClass="language-selector-panel"
        disableOptionCentering [ngClass]="{'select-open': languageIsOpen}" (openedChange)="handleLanguageSelector()">
        <mat-option *ngIf="selectedLanguage !== 'es'" value="es" [innerHTML]="'header_Data5' |i18n: translationModes.PLACEHOLDER"></mat-option>
      <mat-option *ngIf="selectedLanguage !== 'en'" value="en" [innerHTML]="'header_Data6' |i18n: translationModes.PLACEHOLDER"></mat-option>
      <mat-option *ngIf="selectedLanguage !== 'pt'" value="pt" [innerHTML]="'header_Data7' |i18n: translationModes.PLACEHOLDER"></mat-option>
      <mat-option *ngIf="selectedLanguage !== 'fr'" value="fr" [innerHTML]="'header_Data8' |i18n: translationModes.PLACEHOLDER"></mat-option>
      <mat-option value="eus" [innerHTML]="'header_Data9' |i18n: translationModes.PLACEHOLDER"></mat-option>
      <mat-option value="cat" [innerHTML]="'header_Data10' |i18n: translationModes.PLACEHOLDER"></mat-option>
      </mat-select>
    </div> -->
    <div class="btn register" [innerHTML]="'header_Data3' |i18n" [routerLink]="getRouterLink('Register')"></div>
    <div class="btn login" [innerHTML]="'header_Data4' |i18n" [routerLink]="getRouterLink('Login')"></div>
    <div class="social">
      <a href="https://www.instagram.com/eyesnroad/" target="_blank">
        <img src="/assets/images/social/ig-icon.svg" alt="Instagram icon">
      </a>
      <a href="https://www.youtube.com/channel/UCID-e2P38WyoLsfNelzuv7w" target="_blank">
        <img src="/assets/images/social/yt-icon-header.svg" alt="Youtube icon">
      </a>
      <a href="https://www.linkedin.com/showcase/eyesnroad/?originalSubdomain=es" target="_blank">
        <img src="/assets/images/social/linkedin-icon.svg" alt="Linkedin icon">
      </a>
    </div>
  </div>
</nav>
